<script setup async lang="ts">
import { useSEO } from '../composables/seo'
import 'floating-vue/dist/style.css'
// defineOgImageScreenshot()

const { GenerateTags } = useSEO()

GenerateTags({
  title: '💪 Champs! 📈',
  desc: 'Crappy Stats of OTB\'s Crappy Quiz',
})
</script>

<template>
  <div>
    <div>
      <TheTopThree />
    </div>
  </div>
</template>

<style>

</style>
